import React from 'react'
import useFeatureFlags from 'hooks/useFeatureFlags'
import { EMARMedicationStockScreen } from './EMARMedicationStockScreen'
import { EMARMedicationStockScreenV2 } from '../ResidentEmarV2Screens/EMARMedicationStockScreenV2'

const EMARMedicationStockScreenWrapper: React.FC = () => {
  const flags = useFeatureFlags({ flagNames: ['emar_v2_stock'] })?.data

  const newEmarEnabled = flags?.emar_v2_stock?.enabled ?? false

  if (newEmarEnabled) {
    return <EMARMedicationStockScreenV2 />
  }

  return <EMARMedicationStockScreen />
}

export default EMARMedicationStockScreenWrapper
